import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicosPage = lazy(() => import('../pages/servicos/page'));
const SobrePage = lazy(() => import('../pages/sobre/page'));
const CanalizacaoPage = lazy(() => import('../pages/canalizacao/page'));
const RemodelacaoCasaBanhoPage = lazy(() => import('../pages/remodelacao-casa-de-banho/page'));
const PinturaPage = lazy(() => import('../pages/pintura/page'));
const InstalacaoPisoFlutuantePage = lazy(() => import('../pages/instalacao-piso-flutuante/page'));
const ReparacaoEletricaPage = lazy(() => import('../pages/reparacao-eletrica/page'));
const GaleriaPage = lazy(() => import('../pages/galeria/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogPostPage = lazy(() => import('../pages/blog/post'));
const ObrigadoPage = lazy(() => import('../pages/obrigado/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/servicos',
    element: <ServicosPage />,
  },
  {
    path: '/sobre',
    element: <SobrePage />,
  },
  {
    path: '/canalizacao',
    element: <CanalizacaoPage />,
  },
  {
    path: '/remodelacao-casa-de-banho',
    element: <RemodelacaoCasaBanhoPage />,
  },
  {
    path: '/pintura',
    element: <PinturaPage />,
  },
  {
    path: '/instalacao-piso-flutuante',
    element: <InstalacaoPisoFlutuantePage />,
  },
  {
    path: '/reparacao-eletrica',
    element: <ReparacaoEletricaPage />,
  },
  {
    path: '/galeria',
    element: <GaleriaPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogPostPage />,
  },
  {
    path: '/obrigado',
    element: <ObrigadoPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;